import { version } from '../version.js';
export const getVersion = () => `@wagmi/core@${version}`;
//# sourceMappingURL=getVersion.js.map